import React from 'react';
import { skills } from '../data/mock';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

const Skills = () => {
  const categories = [
    { key: 'mobile', label: 'Mobile Development', color: 'bg-blue-500' },
    { key: 'ml', label: 'Machine Learning', color: 'bg-green-500' },
    { key: 'backend', label: 'Backend & Cloud', color: 'bg-purple-500' },
    { key: 'tools', label: 'Tools & Version Control', color: 'bg-orange-500' },
    { key: 'design', label: 'Design', color: 'bg-pink-500' }
  ];

  const groupedSkills = categories
    .map(category => ({
      ...category,
      skills: skills.filter(skill => skill.category === category.key)
    }))
    .filter(group => group.skills.length > 0);

  return (
    <section id="skills" className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4 text-center">
          Tech Stack
        </h2>
        <p className="text-center text-muted-foreground mb-12 max-w-2xl mx-auto">
          Technologies and tools I use behind my projects
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {groupedSkills.map((group) => (
            <Card key={group.key} className="border-border shadow-md">
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <div className={`w-3 h-3 rounded-full ${group.color}`}></div>
                  {group.label}
                </CardTitle>
              </CardHeader>

              <CardContent>
                <ul className="flex flex-wrap gap-2">
                  {group.skills.map((skill, index) => (
                    <li
                      key={index}
                      className="px-3 py-1 text-sm rounded-md bg-secondary text-secondary-foreground"
                    >
                      {skill.name}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
